export const ADMIN_RESET_ALL = 'ADMIN_RESET_ALL'
export const ADMIN_TOKEN = 'ADMIN_TOKEN'
export const ADMIN_USER_ID = 'ADMIN_USER_ID'
export const ADMIN_NICK_NAME = 'ADMIN_NICK_NAME'
export const ADMIN_AVATAR = 'ADMIN_AVATAR'
export const ADMIN_SYSTEM_NAME = 'ADMIN_SYSTEM_NAME'
export const ADMIN_SYSTEM_LOGO = 'ADMIN_SYSTEM_LOGO'

